module.exports = "<div class=\"map\" [attr.id]=\"id\"></div>\n<!-- Map buttons if available -->\n<div *ngIf=\"buttons\" class=\"btns\">\n  <button (click)=\"setCenter(button)\" *ngFor=\"let button of buttons\" [class.active]=\"isButtonActive(button)\" class=\"office-btn\">\n    {{button.text}}\n  </button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/+app/shared/map/map.component.html
// module id = 598
// module chunks = 0